module.exports = "<div [formGroup]=\"parent\">\n\n  <p>\n    <mat-form-field [style.width]=\"width\">\n      <input type=\"text\" matInput [placeholder]=\"attribute.label\" [formControlName]=\"attribute.value\" required>\n      <mat-error *ngIf=\"invalid.required\">{{attribute.label}} is required</mat-error>\n      <mat-error *ngIf=\"invalid.email\">{{attribute.label}} must be valid email address</mat-error>\n    </mat-form-field>\n  </p>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/attribute/attribute.component.html
// module id = ./src/app/shared/attribute/attribute.component.html
// module chunks = main